/**
 * User Intention Model
 * Represents personal goals and intentions set by users during onboarding
 */
export interface Intention {
  id: string;
  text: string;
  createdAt: Date | string;
  updatedAt?: Date | string;
  active: boolean;
  category?: string;
}

export function createIntention(
  text: string,
  category?: string
): Intention {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    text: text.trim(),
    createdAt: now,
    updatedAt: now,
    active: true,
    category,
  };
}
